/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage } from 'react-intl';

interface Props {
  query: string;
}
const NoResults: React.FC<Props> = (props) => (
  <div>
    <pre  style={{ marginTop: '30px', textAlign: 'center', lineHeight: '50px', whiteSpace: 'pre-wrap' }}>
      <div className="font-body font-color-gsDark">
        <FormattedMessage
          id="search.noResults.message.text"
          values={{
            string1: props.query,
          }}
        />
      </div>
    </pre>
  </div>
);

export default NoResults;
